import React from 'react';
import Card from '../components/card';
import Checkbox from '../components/Checkbox';
import { lightGray } from '../shared/theme';
import { LoanCard } from './card-lenses';

// all the properties that can be set by this card
const properties = [
  {
    name: 'otherProperty',
    label: 'Own other real estate',
    checked: true
  },
  {
    name: 'ownsCompany',
    label: 'Own 25% or more of a company',
    checked: true
  },
  {
    name: 'taxesFiled',
    label: 'Filed tax returns late over the past 2 years without filing an extension',
    checked: false
  },
  {
    name: 'citizen',
    label: 'Not a US citizen or permanent resident',
    checked: false
  },
  {
    name: 'lawsuit',
    label: 'Party to a lawsuit',
    checked: true
  },
  {
    name: 'paysAlimony',
    label: 'Pay child support or alimony',
    checked: true
  }
];

const titleText = (model) =>
  model.get('hasCoborrower')
    ? 'Which of the following apply to you or your co-borrower?'
    : 'Which of the following apply to you?';

const areNoneSelected = (model) =>
  properties.every(({ name, checked }) => model.get(name) === !checked);

class Disqualifying extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstclick: true,
      // default the "None of the Above" if all properties are set
      noneSelected: areNoneSelected(props.model)
    };
    this.onChange = this.onChange.bind(this);
    this.noneClicked = this.noneClicked.bind(this);
  }

  componentWillReceiveProps({ model }) {
    this.setState({
      noneSelected: areNoneSelected(model)
    });
  }

  onChange(property, value) {
    if (this.state.firstclick) {
      // the first click on a checkbox sets any unset properties
      properties
        .filter(({ name }) => name !== property)
        .forEach(({ name, checked }) => {
          if (this.props.model.get(name) == null) {
            this.props.onChange(name, !checked);
          }
        });
      this.setState({
        firstclick: false
      });
    }

    this.props.onChange(property, value);
  }

  noneClicked(value) {
    if (value) {
      properties.forEach(({ name, checked }) => this.props.onChange(name, !checked));
    }
    this.setState({
      // Never allow this to "uncheck"
      noneSelected: true,
      firstclick: false
    });
  }

  render() {
    const { model, onChange: _, ...cardProps } = this.props;
    return (
      <Card title={titleText(model)} {...cardProps}>
        {properties.map((property, i) => (
          <Checkbox
            key={i}
            style={{ marginTop: '0.5em' }}
            label={property.label}
            value={model.get(property.name) === property.checked}
            onChange={(value) =>
              this.onChange(property.name, value ? property.checked : !property.checked)
            }
          />
        ))}
        <hr style={{ borderColor: lightGray, borderStyle: 'solid' }} />
        <Checkbox
          style={{ marginTop: '0.5em' }}
          label="None of the above applies"
          value={this.state.noneSelected}
          onChange={this.noneClicked}
        />
      </Card>
    );
  }
}

Disqualifying.completed = ({ model }) => properties.every(({ name }) => model.get(name) != null);

Disqualifying.id = 'Disqualifying';

export default LoanCard(Disqualifying);



// WEBPACK FOOTER //
// ./src/cards/disqualifying.js